
export default {
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    methods: {
        watchAll: function (props, watcher) {
            var iterator = function (prop) {
                this.$watch(prop, watcher);
            };
            props.forEach(iterator, this);
        }
    }
}